import { Popup } from '@approvalmax/ui';
import { selectors, ui } from 'modules/common';
import { State } from 'modules/data';
import { FC, memo, useState } from 'react';
import bemFactory from 'react-bem-factory';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { getRequest, isLoading } from '../../../selectors/pageSelectors';
import { ResubmitRequestParams } from '../ActionsBlock/ActionsBlock.types';
import { messages } from './ResubmitRequestPopup.messages';

const Content = styled.div`
    padding: 10px 60px 40px 80px;
    border-top: 1px solid #ebeaea;
`;

const Description = styled.div`
    margin-top: 10px;
`;

const CommentEditor = styled(ui.AddCommentEditor)`
    margin-top: 50px;
`;

interface ResubmitRequestPopupProps {
    resubmitRequest: (params: ResubmitRequestParams) => void;
}

export const ResubmitRequestPopup: FC<ResubmitRequestPopupProps> = memo((props) => {
    const { resubmitRequest } = props;
    const [commentText, setCommentText] = useState('');

    const templateName = useSelector(
        (state: State) =>
            selectors.template.getTemplateDisplayNameByCode(getRequest(state).integrationCode) ||
            messages.standaloneRequestName
    );
    const loading = useSelector(isLoading);

    const qa = bemFactory.qa('reqf-resubmit-request-popup');

    const onDone = () => {
        resubmitRequest({ commentText });
    };

    return (
        <Popup.DefaultContent
            qa={qa()}
            title={messages.popupTitle({ templateName })}
            buttons={
                <Popup.DefaultContent.Button
                    qa={qa('done-button')}
                    disabled={loading}
                    execute={onDone}
                    title={messages.doneButtonTitle}
                >
                    {messages.doneButtonText}
                </Popup.DefaultContent.Button>
            }
        >
            <Content>
                <Description>{messages.popupDescription({ templateName })}</Description>

                <Description>{messages.popupNote({ templateName })}</Description>

                <CommentEditor
                    qa={qa('comment-editor')}
                    focusOnMount
                    value={commentText}
                    onChange={setCommentText}
                    changeOnBlur
                />
            </Content>
        </Popup.DefaultContent>
    );
});

ResubmitRequestPopup.displayName = 'ResubmitRequestPopup';
